import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { AddUsers } from '../../../models/adduser/adduser/adduser.module';
import { AddUsersService } from '../../../services/add-users.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-agregarusuarios',
  templateUrl: './agregarusuarios.component.html',
  styleUrls: ['./agregarusuarios.component.css']
})
export class AgregarusuariosComponent implements OnInit {
  adduser: AddUsers;
  deluser: AddUsers;
  status: string;
  cat;
  token;
  agregar_usuario: any;
  email: string;
  addcliente: AddUsers;
  addclienteRegister: AddUsers;
  loadingUser = false;
  loadingCliente = false;
  loadingClienteR = false;
  id: number;
  // tslint:disable-next-line: variable-name
  constructor(private _userService: UserService, private _adduser: AddUsersService) {

    const user = this._userService.getIdentity();
    const token = this._userService.getToken();
    this.email = user.email;
    this.id = user.sub;
    this.token = token;

    this.adduser = new AddUsers('', '', '', 0, this.id);
    this.deluser = new AddUsers('', '', '', 0, this.id);
    this.addcliente = new AddUsers('', '', '', 0, this.id);
    this.addclienteRegister = new AddUsers('', '', '', 0, this.id);

    this.getData();
  }

  ngOnInit(): void {
    console.log(this.agregar_usuario);
  }

  getData() {
    this._adduser.getUsers(this.email, this.token).subscribe(
      response => {
        this.agregar_usuario = response;
        //console.log(this.agregar_usuario);
      },
      error => {
        console.log(error);
        const message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(<any>error);
          }
        );
      }
    );
  }

  onSubmitRegister(form) {
    this.loadingUser = true;
    this._adduser.addUser(this.adduser, this.token).subscribe(
      response => {
        this.adduser = new AddUsers('', '', '', 0, this.id);
        form.reset();
        this.getData();
        this.loadingUser = false;
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: response.message,
          showConfirmButton: false,
          timer: 1500
        });
      },
      error => {
        console.log(error);
        let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(<any>error);
          }
        );
      }
    );
  }
  elimina_usuario_equipo(id) {
    this.deluser = new AddUsers('', '', '', 0, id);
    Swal.fire({
      title: '¿Eliminar del Equipo?',
      text: 'Desea eliminar el usuario del equipo',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {
        this._adduser.delUser(this.deluser, this.token).subscribe(
          response => {
            this.deluser = new AddUsers('', '', '', 0, this.id);
            this.getData();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1500
            });
          },
          error => {
            console.log(error);
            let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
            this._userService.register_error(message_error, this.token).subscribe(
              response2 => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'warning',
                  title: response2.message,
                  showConfirmButton: false,
                  timer: 2000
                });
              },
              error => {
                console.log(<any>error);
              }
            );
          }
        );
      }
    });

  }
  onSubmitUser(form) {
    this.loadingCliente = true;
    console.log(this.addcliente);
    this._adduser.addCliente(this.addcliente, this.token).subscribe(
      response => {
        console.log(response);
        this.addcliente = new AddUsers('', '', '', 0, this.id);
        form.reset();
        this.getData();
        this.loadingCliente = false;
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: response.message,
          showConfirmButton: false,
          timer: 1500
        });
      },
      error => {
        console.log(error);
        let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(<any>error);
          }
        );
      }
    );
  }

  onSubmitClienteR(form) {
    this.loadingClienteR = true;
    console.log(this.addclienteRegister);
    this._adduser.registerCliente(this.addclienteRegister, this.token).subscribe(
      response => {
        this.addclienteRegister = new AddUsers('', '', '', 0, this.id);
        form.reset();
        this.getData();
        this.loadingClienteR = false;
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: response.message,
          showConfirmButton: false,
          timer: 1500
        });
      },
      error => {
        console.log(error);
        let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(<any>error);
          }
        );
      }
    );
  }
  elimina_cliente_equipo(id) {
    this.deluser = new AddUsers('', '', '', 0, id);
    Swal.fire({
      title: '¿Eliminar del Equipo?',
      text: 'Desea eliminar el usuario del equipo',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {
        this._adduser.delCliente(this.deluser, this.token).subscribe(
          response => {
            this.deluser = new AddUsers('', '', '', 0, this.id);
            this.getData();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1500
            });
          },
          error => {
            console.log(error);
            let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
            this._userService.register_error(message_error, this.token).subscribe(
              response2 => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'warning',
                  title: response2.message,
                  showConfirmButton: false,
                  timer: 2000
                });
              },
              error => {
                console.log(<any>error);
              }
            );
          }
        );
      }
    });

  }
}
